var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2588 13.498H9.44845C9.32372 13.498 9.22266 13.5994 9.22266 13.7244V22.7733C9.22266 22.8983 9.32372 22.9996 9.44845 22.9996H12.2588C12.3836 22.9996 12.4846 22.8983 12.4846 22.7733V13.7244C12.4846 13.5994 12.3836 13.498 12.2588 13.498Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8545 9C9.83192 9 9 9.83289 9 10.8566C9 11.8809 9.83192 12.7141 10.8545 12.7141C11.8763 12.7141 12.7075 11.8808 12.7075 10.8566C12.7076 9.83289 11.8763 9 10.8545 9Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4082 13.2734C18.2794 13.2734 17.445 13.7598 16.9389 14.3124V13.7246C16.9389 13.5997 16.8379 13.4983 16.7131 13.4983H14.0217C13.897 13.4983 13.7959 13.5997 13.7959 13.7246V22.7736C13.7959 22.8986 13.897 22.9999 14.0217 22.9999H16.8259C16.9507 22.9999 17.0517 22.8986 17.0517 22.7736V18.2964C17.0517 16.7878 17.4606 16.2 18.5099 16.2C19.6527 16.2 19.7435 17.1422 19.7435 18.3741V22.7736C19.7435 22.8986 19.8446 22.9999 19.9693 22.9999H22.7746C22.8994 22.9999 23.0004 22.8986 23.0004 22.7736V17.8101C23.0004 15.5668 22.5736 13.2734 19.4082 13.2734Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a24f8ac49d85ee13e0060e7290df1144.svg";
export { ForwardRef as ReactComponent };